import { render, staticRenderFns } from "./OspfList.vue?vue&type=template&id=2a7b41c8&scoped=true&"
import script from "./OspfList.vue?vue&type=script&lang=js&"
export * from "./OspfList.vue?vue&type=script&lang=js&"
import style0 from "./OspfList.vue?vue&type=style&index=0&id=2a7b41c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b41c8",
  null
  
)

export default component.exports